export const CLOSED_SALESFORCE_CASE_STATUSES = ['Closed', 'Merged'];
